<template>
  <div></div>
</template>
<script>
import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import gql from 'graphql-tag';
let amplitude;
if (process.browser) {
  amplitude = require('amplitude-js');
  amplitude.getInstance().init(process.env.VUE_APP_AMPLITUDE_KEY);
}
import Fingerprint2 from 'fingerprintjs2';

const Ana = {};
const ANA_MAX_EVENTS = 10;
const ANA_WAIT = 4 * 1000;
let ANA_EVENTS = [];
let ANA_TIMEOUT = null;

async function sendAnaEvents($apollo, fingerprint, activityId) {
  const toSend = cloneDeep(ANA_EVENTS);
  ANA_EVENTS = [];
  const t = new Date().getTime();
  const events = JSON.stringify(toSend.map( (e) => {
    e.d = t - e.t;
    delete e.t;
    return e;
  }));

  const payload = {
    deviceid: fingerprint,
    url: window.location.href,
    activityId,
    timestamp: 'unknown',
    events
  }
  await $apollo.mutate({
    fetchPolicy: 'no-cache',
    mutation:gql(`
      mutation ana($deviceid: String!, $url: String!, $activityId: String, $timestamp: String, $events: String) {
        ana(deviceid: $deviceid, url: $url, activityId: $activityId, timestamp: $timestamp, events: $events)
      }
    `),
    variables:payload
  });
  clearTimeout(ANA_TIMEOUT);


  /*
  for (let i = 0; i < toSend.length; i++) {
    const event = toSend[i];
    console.log('ANA send event', event);
    await $apollo.mutate({
      fetchPolicy: 'no-cache',
      mutation:gql(`
                   mutation ana($deviceid: String!, $eventCategory: String!, $eventAction: String!, $url: String!, $extra: String) {
                     ana(deviceid: $deviceid, eventCategory: $eventCategory, eventAction: $eventAction, url: $url, extra: $extra)
                   }
                   `),
                   variables:event
    });
    clearTimeout(ANA_TIMEOUT);
  }
  if (ANA_EVENTS.length) {
    setTimeout(sendAnaEvents.bind(sendAnaEvents, $apollo), ANA_WAIT);
  }
  */
}

export default {
  data() {
    return {
      started: false,
      fingerprint:'',
    }
  },
  async mounted() {
    if (!process.browser) {
      return;
    }
    this.$eventbus.on('ana', this.logAna);

    const excludes = {
      canvas: true,
      webdriver: true,
      deviceMemory: true,
      hardwareConcurrency: true,
      enumerateDevices: true,
      // enumerateDevices: true,
      fonts: true,
      webgl: true,
      indexedDb: true,
      addBehavior: true,
      openDatabase: true,
      doNotTrack: true,
      plugins: true,
      adBlock: true,
      audio: true
    };
    const $apollo = this.$apollo;
    const $store = this.$store;
    Fingerprint2.get({excludes}, async (components) => {
      const values = components.map( ({value}) => { return value });

      const userAgents = components.find( ({key}) => { return key === 'userAgent'});
      const fingerprint = Fingerprint2.x64hash128(values.join(''))
      this.fingerprint = fingerprint;

      const comps = {};
      components.forEach( ({key,value}) => {
        comps[key] = value;
      });

      const deviceid = fingerprint;
      const userAgent = comps.userAgent || 'unknown';
      const resolution = [window.innerWidth, window.innerHeight].join('x');
      const timezone = comps.timezone || 'unknown';
      const platform = comps.platform || 'unknown';

      const variables = {
        deviceid,
        userAgent,
        resolution,
        timezone,
        platform,
      }
      //console.log('starting ana', variables);
      const start = await $apollo.mutate({
        fetchPolicy: 'no-cache',
        mutation:gql(`
        mutation anaStart(
        $deviceid: String!,
        $userAgent: String!,
        $resolution: String!,
        $timezone: String!,
        $platform: String!) {
          anaStart(
          deviceid: $deviceid,
          userAgent: $userAgent,
          resolution: $resolution,
          timezone: $timezone,
          platform: $platform)
        }
        `),
        variables
      });

      this.fingerprint = fingerprint;
      //console.log('have fingerprint', this.fingerprint);
      this.$store.commit('setFingerprint', this.fingerprint);
      this.started = true;
    });
  },
  methods: {
    async logAna({eventCategory, eventAction, extra}) {
      //console.log('[ANA TRACK] ======== track', eventCategory, eventAction, JSON.stringify(extra));
      if (this.$gtag) {
        this.$gtag.event([eventCategory, eventAction].join('-'), {
          event_category: eventCategory,
          event_label: eventAction
        });
      }

      amplitude.getInstance().logEvent(
        [eventCategory, eventAction].join('-'),
        {
          eventCategory,
          eventAction,
          ...extra
        }
      );

      if (eventCategory === 'engagement' || eventCategory === 'ui') {
        console.log('LOG TO FACEBOOKSSSSSSSSSSS');
        try {
          const eventName = [eventCategory, eventAction].join('-');
          if (typeof(fbq) !== 'undefined') {
            fbq('trackCustom', eventName, extra);
          }
        } catch (e) {
          console.error('le ad block?', e);
        }
      }

      if (!this.started) {
        //console.log('not started');
        return;
      }

      const $apollo = this.$apollo;
      const $store = this.$store;

      if (true) {
        ANA_EVENTS.push({
          t:new Date().getTime(),
          eventCategory: eventCategory,
          eventAction: eventAction,
          extra: JSON.stringify(extra)
        });
        if (ANA_TIMEOUT) {
          clearTimeout(ANA_TIMEOUT);
        }
        if (ANA_EVENTS.length >= ANA_MAX_EVENTS) {
          sendAnaEvents($apollo, this.fingerprint, this.currentActivityId)
        } else {
          //console.log('set timeout for ana');
          ANA_TIMEOUT = setTimeout(sendAnaEvents.bind(sendAnaEvents, $apollo, this.fingerprint, this.currentActivityId), ANA_WAIT);
        }
      };
      /*
      Vue.prototype.$apollo.query({
      query:gql(`
      `)
      });
      */
      //Vue.prototype.$segment.trackEvent(name, data);



    }
  },
  watch: {
    '$route.name'(nv) {
      sendAnaEvents(this.$apollo, this.fingerprint, this.currentActivityId);
      if (nv !== 'editTemplate' && nv !== 'create') {
        this.$store.commit('setCurrentActivityId', '');
      }
    },
    'currentActivityId'(ov) {
      sendAnaEvents(this.$apollo, this.fingerprint, ov);
    }
  },
  computed: {
    ...mapState(['currentActivityId'])
  }
}


</script>
